<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-6">
        <img class="img-fluid mb-3 mb-sm-0" src="@/assets/images/NBHD.jpg" alt="">
      </div>

      <div class="col-sm-6 d-flex flex-column justify-content-center">
        <router-link to="/brandintro/neighborhood">
          <h2 class="font-italic text-dark text-center mb-4">NEIGHBORHOOD</h2>
        </router-link>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-sm-6 order-sm-1">
        <img class="img-fluid mb-3 mb-sm-0" src="@/assets/images/WTAPS.jpg" alt="">
      </div>

      <div class="col-sm-6 d-flex flex-column justify-content-center">
        <router-link to="/brandintro/wtaps">
          <h2 class="font-italic text-dark text-center mb-4">WTAPS</h2>
        </router-link>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-sm-6">
        <img class="img-fluid mb-3 mb-sm-0" src="@/assets/images/CRHT.jpg" alt="">
      </div>

      <div class="col-sm-6 d-flex flex-column justify-content-center">
        <router-link to="/brandintro/carharttwip">
          <h2 class="font-italic text-dark text-center mb-4">CARHARTT WIP</h2>
        </router-link>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-sm-6 order-sm-1">
        <img class="img-fluid mb-3 mb-sm-0" src="@/assets/images/VISVIM.jpg" alt="">
      </div>

      <div class="col-sm-6 d-flex flex-column justify-content-center">
        <router-link to="/brandintro/visvim">
          <h2 class="font-italic text-dark text-center mb-4">visvim</h2>
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  components: {
    
  },
  
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/BrandIntro.vue